import { useCallback } from 'react';

import { userStore } from '@p/security/users/store/store';

import { UserFilterForm } from '@t/user/components/filter/field-values.schema';

export const useFilterConfiguration = () => {
  const { isOpenFilter, setIsOpenFilter } = userStore();

  const handleSubmitted = useCallback(
    (formData: UserFilterForm) => {
      formData;
      setIsOpenFilter(false);
    },
    [setIsOpenFilter]
  );

  return { handleSubmitted, isOpenFilter, setIsOpenFilter };
};
